<template>
  <CModal
    :title="isChallenge ? 'Challenge Votes' : 'Idea Votes'"
    :show.sync="detailModal"
    centered
    size="sm"
  >
    <template v-slot:body-wrapper>
      <div
        class="modal-body overflow-auto"
        style="max-height: calc(100vh - 11.6rem)"
      >
        <div
          v-for="(item, i) in votes"
          :key="`vote-${i}`"
          class="form-row mb-2 align-items-center"
        >
          <div class="col-2">
            <img
              :src="`${$http.defaults.baseURL}/Document/download/Employees/${item.Email}.jpg`"
              class="rounded-circle w-100"
              @error="replaceByDefault"
            />
          </div>
          <div class="col-10">
            <strong>{{ item.Name }}</strong>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer-wrapper>
      <div></div>
    </template>
  </CModal>
</template>

<script>
export default {
  props: ["entityId", "isChallenge"],
  data() {
    return {
      detailModal: false,
      votes: [],
    };
  },
  watch: {
    async entityId(val) {
      this.detailModal = !!val;
      if (val) {
        await this.loadVotes(val);
      }
    },
    detailModal(val) {
      if (!val) {
        this.$emit("update:entityId", 0);
      }
    },
  },
  methods: {
    async loadVotes(entityId) {
      let result = [];
      let entity = this.isChallenge ? "SipChallenge" : "SipIdea";
      let expandEntity = this.isChallenge
        ? "SipChallengeVotes"
        : "SipIdeaVotes";
      let resp = await this.$http.get(`odata/${entity}`, {
        params: {
          $top: 1,
          $select: "Id",
          $filter: `Id eq ${entityId}`,
          $expand: `${expandEntity}($select=Id;$orderby=CreatedAt desc;$expand=User($select=FirstName,Name,Email))`,
          isAll: true,
        },
      });
      if (resp && resp.status == 200) {
        result =
          resp.data.value && resp.data.value.length
            ? resp.data.value[0][expandEntity].map((_) => {
                return {
                  FirstName: _.User.FirstName,
                  Name: _.User.Name,
                  Email: _.User.Email,
                };
              })
            : [];
      }
      this.votes = Array.from(new Set(result.map(JSON.stringify))).map(
        JSON.parse
      );
    },

    replaceByDefault(e) {
      e.target.src = "/img/avatar.png";
    },
  },
};
</script>
